import type { Filters } from '@lt/api/dist/methods/explore/types';
import FILTERS_LIST from 'src/components/Filters';
import type { FilterParams, FormattedFilters } from './types';

/**
 * Преобразовывает фильтры в объект, который
 * содержит лейблы и описания для фильтров.
 * Это преобразование позволяет отрисовывать
 * фильтры из предыдущего поиска
 * @param {Filters} filters
 * @returns {FormattedFilters} formattedFilters
 */
export const formatPreviousFilters = (
  filters: Partial<Filters>,
): FormattedFilters | null => {
  try {
    const formattedFilters: FormattedFilters = [];
    FILTERS_LIST.forEach((Filter) => {
      const {
        filterLabel,
        filterName,
        valuesLabel,
        customFilters,
        FILTER_NAMES,
      } = Filter;
      const currentFilters = filters[filterName] as FilterParams | undefined;
      if (!currentFilters && !customFilters) return;
      /**
       * customFilters - поле в Filter, которое показывает,
       * что имена нужно брать из FILTER_NAMES
       */
      if (customFilters && FILTER_NAMES) {
        const chosenCustomFilters = customFilters.filter((customFilter) =>
          Boolean(filters[customFilter]),
        );
        if (!chosenCustomFilters.length) return;
        /**
         *  id и description у customFilters нужно собирать
         *  со всех выбранных фильтров, label же у них общий
         */
        formattedFilters.push({
          ...chosenCustomFilters.reduce(
            (acc, customFilter, index) => ({
              id: index !== 0 ? `${acc.id},${customFilter}` : customFilter,
              description:
                index !== 0
                  ? `${acc.description}, ${FILTER_NAMES[customFilter]}`
                  : FILTER_NAMES[customFilter],
            }),
            {},
          ),
          selected: true,
          label: filterLabel,
        });
        return;
      }
      if (currentFilters)
        formattedFilters.push({
          id: filterName,
          selected: true,
          label: filterLabel,
          /**
           * У некоторых фильтров явно прописана функция valuesLabel,
           * которая возвращает текст, который нужно показать
           * А для тех фильтров, у кого ее нет, нужно собирать
           * имена всех ВЫБРАННЫХ фильтров
           */
          description: valuesLabel
            ? valuesLabel(currentFilters)
            : currentFilters
                .filter(({ selected }) => selected)
                .map(({ name }) => name)
                .join(', '),
        });
    });
    return formattedFilters;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    return null;
  }
};
